import { Outlet } from 'react-router-dom'
function Auth() {
  return (
    <div className='AppMain'>
      <Outlet />
    </div>
  )
}

export default Auth
